import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { useTable, useSortBy, useFilters } from 'react-table';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import useTheme from '@material-ui/core/styles/useTheme';
import SplashScreen from "./splashScreen/SplashScreen";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import {splashScreen} from "../portfolio";
import Grid from '@material-ui/core/Grid';

import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import Loading from "../containers/loading/Loading";

import { CSVLink } from 'react-csv';
import { useParams } from 'react-router-dom'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import monthsData from './constants';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const useStyles = makeStyles((theme) => ({
  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 5,
      fontSize: 15,
    },
  },
  autocomplete: {
    width: 350,
    margin: '20px',
  },
}));

const ExportToCSV = ({ data, headers, filename, what }) => (
  <CSVLink data={data} headers={headers} filename={filename}>
    <Button variant="outlined" size="small" style={{ backgroundColor: '#008c96', color: '#ffffff' }}>Export {what} to CSV</Button>
  </CSVLink>
);

const columns1 = [
  {
    Header: 'Number',
    accessor: 'Number',
  },
  {
    Header: 'Page Name',
    accessor: 'Page',
  },
  {
    Header: 'PR Number',
    accessor: 'Pull Request',
  },
  {
    Header: 'Status',
    accessor: 'Status',
  },
  {
    Header: 'Ticket Number',
    accessor: 'Ticket Number',
  },
  {
    Header: 'Date',
    accessor: 'Date',
  },
];

const columns2 = [
  {
    Header: 'Number',
    accessor: '_Number_',
  },
  {
    Header: 'Page Name',
    accessor: '_Page_',
  },
  {
    Header: 'PR Number',
    accessor: '_Pull Request_',
  },
  {
    Header: 'Status',
    accessor: '_Status_',
  },
  {
    Header: 'Ticket Number',
    accessor: '_Ticket Number_',
  },
  {
    Header: 'Date',
    accessor: '_Date_',
  },
  {
    Header: 'Comments',
    accessor: 'Comments',
  },
];

export default function MarktPilot() {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const { id = 'none' } = useParams();

  const ids = [
    {
      "id": "apr24",
      "key": "April 2024",
      "startDateStr": "2024-04-02",
      "endDateStr": "2024-04-30",
    },
    {
      "id": "may24",
      "key": "May 2024",
      "startDateStr": "2024-05-01",
      "endDateStr": "2024-05-31",
    },
    {
      "id": "jun24",
      "key": "June 2024",
      "startDateStr": "2024-06-01",
      "endDateStr": "2024-06-30",
    },
    {
      "id": "jul24",
      "key": "July 2024",
      "startDateStr": "2024-07-01",
      "endDateStr": "2024-07-31",
    },
    {
      "id": "aug24",
      "key": "August 2024",
      "startDateStr": "2024-08-01",
      "endDateStr": "2024-09-01",
    },
    {
      "id": "sep24",
      "key": "September 2024",
      "startDateStr": "2024-09-02",
      "endDateStr": "2024-09-30",
    },
    {
      "id": "oct24",
      "key": "October 2024",
      "startDateStr": "2024-10-02",
      "endDateStr": "2024-10-31",
    },
    {
      "id": "nov24",
      "key": "November 2024",
      "startDateStr": "2024-11-01",
      "endDateStr": "2024-11-30",
    }
  ];

  let currentMonth = ids.find((item) => item.id === id);

  if (!currentMonth) {
    currentMonth = ids[ids.length - 1];
  }

  const theme = useTheme();

  theme.palette.primary.main = '#008c96';

  const classes = useStyles(theme);


  const styles = {
    tableContainer: {
      maxHeight: 400,
      overflowY: 'auto',
      overflowX: 'auto',
      margin: '20px',
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: 'honeydew',
      borderRadius: '8px',
      scrollbarWidth: 'thin', // For Firefox compatibility
      scrollbarColor: `${theme.palette.primary.main} ${theme.palette.divider}`, // For Firefox compatibility
    },
    table: {
      borderCollapse: 'collapse',
      minWidth: '100%',
    },
    tableCell: {
      padding: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
      fontSize: '13.5px',
      fontFamily: '"Fira Code", Montserrat, "Montserrat", sans-serif',
    },
    tableHeaderCell: {
      padding: theme.spacing(1),
      borderRight: `1px solid ${theme.palette.divider}`,
      fontWeight: 'bold',
      color: '#FFF',
    },
    tableHeader: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.getContrastText(theme.palette.primary.main),
      position: 'sticky',
      zIndex: '1',
      top: '0', // Add this line to make the headers sticky at the top
    },
    heading: {
      position: 'sticky',
      top: '0',
      backgroundColor: '#fff',
      padding: '10px 20px',
      zIndex: '100',
    },
  };

  const [reviewed, setReviewed] = useState([]);
  const [implemented, setImplemented] = useState([]);
  const [pagesImplementedDateWise, setPagesImplementedDateWise] = useState([]);
  const [pagesReviewedDateWise, setPagesReviewedDateWise] = useState([]);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
  useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  function parseCSV(csvText) {
    const rows = csvText.split(/\r?\n/);
    const headers = rows[1].split(',');
    headers.splice(6, 3);
    const headers1 = headers.slice(0, 6);
    const headers2 = headers.slice(6);
    const data1 = [];
    const data2 = [];
    const dateWiseData1 = {};
    const dateWiseData2 = {};
    for (let i = 2; i < rows.length; i++) {
        const rowData = rows[i].split(',');
        const rowObject1 = {};
        const rowObject2 = {};
        let j = 0;
        for (; j < headers1.length; j++) {
          if (headers1[j] === "No.") {
            rowObject1["Number"] = rowData[j];
          } else {
            rowObject1[headers1[j]] = rowData[j];
          }
        }
        j = 9;
        for (let p = 0; p < headers2.length; j++, p++) {
          if (headers2[p] === "_No._") {
            rowObject2["_Number_"] = rowData[j];
          } else {
            rowObject2[headers2[p]] = rowData[j];
          }
      }
      if (rowObject1["Page"] !== "") {
        data1.push(rowObject1);
        for(let k = 0; k < dateList.length; k++) {
          if (rowObject1["Date"] === dateList[k]) {
            if (dateWiseData1[dateList[k]]) {
              dateWiseData1[dateList[k]] += 1;
            } else {
              dateWiseData1[dateList[k]] = 1;
            }
          }
        }
      }
      if (rowObject2["_Page_"] !== "") {
        data2.push(rowObject2);
        for (let k = 0; k < dateList.length; k++) {
          if (rowObject2["_Date_"] === dateList[k]) {
            if (dateWiseData2[dateList[k]]) {
              dateWiseData2[dateList[k]] += 1;
            } else {
              dateWiseData2[dateList[k]] = 1;
            }
          }
        }
      }
    }
    return [data1, data2, dateWiseData1, dateWiseData2];
  }

  function formatDate(date) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()]; // Getting the first three letters of the month name
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function generateDateList(startDateStr, endDateStr) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const dateList = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      const formattedDate = formatDate(currentDate);
      dateList.push(formattedDate);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateList;
  }

  const startDateStr = currentMonth.startDateStr;
  const endDateStr = currentMonth.endDateStr;
  const dateList = generateDateList(startDateStr, endDateStr);
  const todaysDate = formatDate(new Date());

  const fetchCSVData = () => {
    if (currentMonth.id === "nov24") {
      const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTSK5V8FDGdx57TD6yYrr33WjgvklZwVFf3h5j2J2YynebxxbcfWAkdpmHpZ1PmA9V5ljPplqZgTEa3/pub?gid=2011931544&single=true&output=csv';
      axios.get(csvUrl)
          .then((response) => {
            const parsedCsvData = parseCSV(response.data);
            setReviewed(parsedCsvData[0]);
            setImplemented(parsedCsvData[1]);
            setPagesReviewedDateWise(parsedCsvData[2]);
            setPagesImplementedDateWise(parsedCsvData[3]);
          })
          .catch((error) => {
            console.log('Error while fetching data... ', error);
          });
    } else {
      const parsedCsvData = parseCSV(monthsData[currentMonth.id]);
      setReviewed(parsedCsvData[0]);
      setImplemented(parsedCsvData[1]);
      setPagesReviewedDateWise(parsedCsvData[2]);
      setPagesImplementedDateWise(parsedCsvData[3]);
    }
}

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchCSVData();
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },    
  };

  const backgroundColors = dateList.map((item) => {
    if(item === todaysDate) {
      return "#00FF8F";
    }
    return "#008c96";
  });

  const dateData2 = {
    labels: dateList,
    datasets: [
      {
        data: dateList.map((item) => pagesImplementedDateWise[item]),
        backgroundColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  const dateData1 = {
    labels: dateList,
    datasets: [
      {
        data: dateList.map((item) => pagesReviewedDateWise[item]),
        backgroundColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns: columns1, data: reviewed }, useFilters, useSortBy);

  const table1 = (
    <div style={styles.tableContainer}>
      <Table {...getTableProps()} style={styles.table} id="table-container">
        <TableHead style={styles.tableHeader}>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <TableCell {...column.getHeaderProps()} style={styles.tableHeaderCell}>
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <TableRow {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <TableCell {...cell.getCellProps()} style={styles.tableCell}>
                    {cell.render('Cell')}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );

  const {
    getTableProps: getTableProps2,
    getTableBodyProps: getTableBodyProps2,
    headerGroups: headerGroups2,
    rows: rows2,
    prepareRow: prepareRow2,
  } = useTable({ columns: columns2, data: implemented }, useFilters, useSortBy);

  const table2 = (
    <div style={styles.tableContainer}>
      <Table {...getTableProps2()} style={styles.table}>
        <TableHead style={styles.tableHeader}>
          {headerGroups2.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <TableCell {...column.getHeaderProps()} style={styles.tableHeaderCell}>
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps2()}>
          {rows2.map((row) => {
            prepareRow2(row);
            return (
              <TableRow {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <TableCell {...cell.getCellProps()} style={styles.tableCell}>
                    {cell.render('Cell')}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
  return (
    isShowingSplashAnimation && splashScreen.enabled ? (
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        <SplashScreen />
      </StyleProvider>
    ):(
    <div style={{ textAlign: 'center', fontFamily: '"Fira Code", Montserrat, "Montserrat", sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Autocomplete
          id="months-selector"
          className={classes.autocomplete}
          options={ids}
          classes={{
            option: classes.option,
          }}
          defaultValue={currentMonth}
          autoHighlight
          getOptionLabel={(option) => option.key}
          onChange={(event, newValue) => {
            window.location.href = `/marktPilot/${newValue.id}`;
          }}
          renderOption={(option) => (
            <React.Fragment>
              <span>{option.key}</span>
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Month"
              variant="outlined"
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password',
                style: { fontSize: '28px', padding: '0px'},
              }}
            />
          )}
        />
      </div>
      <h1 style={styles.heading}>
        <img src="https://dev.azure.com/markt-pilot/_apis/GraphProfile/MemberAvatars/9c8fc861-ec8f-42ba-a7eb-ffddbe0a2eb8?overrideDisplayName=SonarPages&size=2" alt="Sonar Pages" width="27" height="27" style={{
          paddingRight: '10px',
        }}/>
        Sonar Pages - {currentMonth.key}
      </h1>
      {reviewed.length === 0 && implemented.length === 0 ? (
        <Loading />
      ) : (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={6} xl={6}>
            <h3>Pages Reviewed / Bug Fixed ({reviewed.length})</h3>
            {table1}
            <ExportToCSV
              data={reviewed.map(row =>
                columns1.map(col => {
                  const value = row[col.accessor];
                  return typeof value === 'object' ? JSON.stringify(value) : value;
                })
              )}
              headers={columns1.map(col => col.Header)}
              filename="talal_reviewed_pages.csv"
              what="Reviewed Pages"
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6} xl={6}>
            <h3>Pages Implemented ({implemented.length})</h3>
            {table2}
            <ExportToCSV
              data={implemented.map(row =>
                columns2.map(col => {
                  const value = row[col.accessor];
                  return typeof value === 'object' ? JSON.stringify(value) : value;
                })
              )}
              headers={columns2.map(col => col.Header)}
              filename="talal_implemented_pages.csv"
              what="Implemented Pages"
            />
          </Grid>
        </Grid>
          <ul style={{
            listStyleType: 'none',
            padding: 0,
            gap: '20px',
          }}>
            <li style={{marginBottom: '10px', fontWeight: 'bold'}}>Total {(reviewed.length*9.5) + (implemented.length*19)} €</li>
          </ul>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={6} xl={6}>
              <h3>Progess: Reviewed / Bug Fixed Pages</h3>
              <Bar data={dateData1} options={options} style={{
                maxHeight: '250px',
                margin: '20px 50px',
                padding: '10px',
              }} />
            </Grid>
            <Grid item xs={12} md={12} lg={6} xl={6}>
              <h3>Progess: Implemented Pages</h3>
              <Bar data={dateData2} options={options} style={{
                maxHeight: '250px',
                margin: '20px 50px',
                padding: '10px',
              }} />
            </Grid>
          </Grid>
        </>
      )}

    </div>)
  )
}
